import { studentTimetableQueryOptions } from '@features/timetables/queries'
import { createFileRoute } from '@tanstack/react-router'
import { ScrollArea } from '@mantine/core'
import { TimetableCard } from '@features/timetables/components/TimetableCard'
import { getTodayDateValue } from '@features/timetables/dateUtils'
import { useStudentTimetable } from '@features/timetables/queries'
import { useState } from 'react'

export const Route = createFileRoute('/_layout/students/$studentNo/timetable')({
    component: RouteComponent,
    loader: async ({ params, context }) => {
        context.queryClient.ensureQueryData(studentTimetableQueryOptions({studentNo: Number(params.studentNo)}))
        return null
    },
    errorComponent: () => <div>Error loading timetable</div>,
    staticData: {
        crumb: {
            label: 'Timetable',
        }
    }
})

function RouteComponent() {

    const { studentNo } = Route.useParams()
    const [date, setDate] = useState(getTodayDateValue)
    const { data: lessons, isLoading, isError } = useStudentTimetable({ studentNo: Number(studentNo), date })

    return (
        <ScrollArea h="100%" type="auto" className="min-h-0" p={'xs'}>
            <TimetableCard
                lessons={lessons}
                loading={isLoading}
                error={isError}
                cardTitle="Timetable"
                timetableType="student"
                date={date}
                onDateChange={setDate}
                style={{ minHeight: '30rem' }}
            />
        </ScrollArea>
    )
}
